import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-2,-1h1v1h-1zM1,-1h1v0.5h-1zM1,-0.5h1.5v0.5h-1.5zM-2,0h0.5v0.5h-0.5zM-1,0h1.5v0.5h-1.5zM1.5,0h0.5v0.5h-0.5zM-1,0.5h1v0.5h-1zM1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'campfire', d: 'M-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h0.5v0.5h-0.5zM0.5,0h1v0.5h-1z' },
    { paint: 'fence', d: 'M-1.5,0h0.5v0.5h-0.5z' },
    {
      paint: 'campfireFlame',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM-0.5,-3h1v0.5h-1zM-1,-2.5h2v0.5h-2zM-1,-2h2.5v0.5h-2.5zM-1.5,-1.5h1v0.5h-1zM0.5,-1.5h1v0.5h-1zM-1,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM-0.5,-0.5h1v0.5h-1z',
    },
    { paint: 'lanternGlow', d: 'M-0.5,-1.5h1v1h-1z' },
  ],
  pixels: 46,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
